import React from "react";
import LeftHalf from "./LeftHalf";
import RightHalf from "./RightHalf";
const Main = () => {
  return (
    <main className="main">
      <LeftHalf></LeftHalf>
      <RightHalf></RightHalf>
    </main>
  );
};
export default Main;
